import React, { useEffect, useState } from 'react';
import { Document, Page, PDFViewer } from '@react-pdf/renderer';
import CSVReader from 'react-csv-reader';
import { Box, Modal, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import axios from 'axios';
import example from './example.pdf';
import products from './products.csv'; // Import the CSV file


const RenderSvg = ({ fileUrl }) => {
  const [svgFile, setSvgFile] = useState('');

  useEffect(() => {
    const fetchSvgUrl = async () => {
      const svgUrl = (await axios.get(fileUrl)).data;
      setSvgFile(svgUrl);
    };
    fetchSvgUrl();
  }, [fileUrl]);

  return <div dangerouslySetInnerHTML={{ __html: svgFile }} />;
};

const RenderImg = ({ fileUrl }) => {
  return <img src={fileUrl} alt="file-preview" />;
};

const RenderPDF = (fileUrl) => {
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [pdfUrl, setPdfUrl] = useState('');

  // useEffect(() => {
  //   const fetchPdf = async () => {
  //     try {
  //       const response = await axios.get('./example.pdf', {
  //         responseType: 'blob' // Important: set responseType to 'blob' to get binary data
  //       });
  //       const pdfBlob = new Blob([response.data], { type: 'application/pdf' });
  //       // eslint-disable-next-line no-shadow
  //       const pdfUrlBlob = URL.createObjectURL(pdfBlob);
  //       setPdfUrl(pdfUrlBlob);
  //     } catch (error) {
  //       console.error('Error fetching PDF:', error);
  //     }
  //   };
  //   fetchPdf();
  //   // Clean up URL object when component unmounts
  //   return () => URL.revokeObjectURL(pdfUrl);
  // }, []);

  // eslint-disable-next-line no-shadow
  const onDocumentLoadSuccess = ({ numPages }) => {
    console.log("YEHA")
    setNumPages(numPages);
  };

  const onDocumentLoadError = (error) => {
    console.log("Error ")
    console.log(error);
    // setNumPages(numPages);
  };

  return (
     
      <Document file={example} 
      // onLoadSuccess={onDocumentLoadSuccess} onLoadError={onDocumentLoadError}
      >
        <Page size="A4" />
      </Document>

  );
};

const MyCSVViewer = () => {
  const handleCSVData = (data, fileInfo) => {
    console.log('Parsed CSV data:', data);
    console.log('CSV file info:', fileInfo);
    // You can process and visualize the CSV data here
  };

  return (
    <div>
      <h1>CSV Viewer</h1>
      <CSVReader
        csv={products}
        onFileLoaded={handleCSVData}
        parserOptions={{
          header: true, // Set to true if the CSV file has a header row
        }}
      />
    </div>
  );
};

const FilePreview = ({ fileType, url, open, handleClose }) => {
  const StyleModal = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 650,
    bgcolor: 'background.paper',
    borderRadius: '10px',
    boxShadow: 24,
    p: 4,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  };

  const previewFiles = ['jpg', 'jpeg', 'png', 'svg'].includes(fileType);

  return (
    <>
      <Modal open={open} onClose={handleClose} aria-labelledby="file-preview-modal" aria-describedby="file-preview-modal-to-user">
        <Box sx={StyleModal}>
          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', width: '100%' }}>
            <IconButton aria-label="close-ticket-modal-btn" size="medium" onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </div>
          {(fileType === 'jpg' || fileType === 'jpeg' || fileType === 'png') && <RenderImg fileUrl={url} />}
          {fileType === 'svg' && <RenderSvg fileUrl={url} />}
          {!previewFiles && <div>No se puede previsualizar este archivo</div>}
          {/* {fileType === 'pdf' && (
            <PDFViewer>
              <RenderPDF fileUrl={url} />
            </PDFViewer>
          )} */}
          {/* {(fileType === 'csv' || fileType === 'xlsx') && <MyCSVViewer />} */}
        </Box>
      </Modal>
    </>
  );
};

export default FilePreview;
